<nav *ngIf="node?.children?.length">
  <ul class="menu-list">
    <ng-container *ngFor="let firstLevel of node?.children">
      @if (firstLevel.title) {
        <li class="js-menu-item" [ngClass]="firstLevel.uid">
          @if (firstLevel.uid === 'MyAccountNavNode') {
            <div>
              <nav-arrow-right icon="settings" class="mobile-settings-item"></nav-arrow-right>
              <sub-menu [node]="firstLevel"></sub-menu>
            </div>
          } @else {
            @if (firstLevel.children?.length) {
              <nav-label
                [node]="removeUrl(firstLevel)"
                classContainer="item-list"
                (click)="open($event)"
                (keyup.enter)="open($event)"
                [attr.tabindex]="0"
              >
              </nav-label>

              <div class="arrow-right-flex-grow">
                <nav-arrow-right class="arrow-right-flex-grow"></nav-arrow-right>

                <sub-menu [node]="firstLevel"></sub-menu>
              </div>
            } @else {
              <nav-label [node]="firstLevel" classContainer="item-list"></nav-label>
            }
          }
        </li>
      }
    </ng-container>
  </ul>
</nav>
